import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "8"
}), 'FiberManualRecordSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FiberManualRecordSharp.js
// module id = 3552
// module chunks = 2